module.exports = __webpack_public_path__ + "static/media/brand-icons.65363c4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/brand-icons.svg
// module id = 4415
// module chunks = 0